export { default } from './MoodTagDucks'
export * from './MoodTagDucks'
